import { analytics } from "MVVM/Analytics";
import { IAllstarUser } from "MVVM/Views/Setup/Components/@types";

const FIRST_ATTRIBUTION_KEY = "firstAttributionId";
const LAST_ATTRIBUTION_KEY = "lastAttributionId";

export const addAttributionParams = (
  url: string,
  userId?: string | null,
): string => {
  try {
    const urlObject = new URL(url);
    const refValue = userId || "anonymous";
    urlObject.searchParams.set("ref", refValue);
    return urlObject.toString();
  } catch (e) {
    return url;
  }
};

export const getAttributionUserId = (allstarUser: IAllstarUser): string => {
  return allstarUser?.user?._id || "anonymous";
};

export const getRefFromUrl = (): string | null => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("ref");
  } catch (e) {
    return null;
  }
};

export const getFirstAttributionId = (): string | null => {
  try {
    return localStorage.getItem(FIRST_ATTRIBUTION_KEY);
  } catch (e) {
    return null;
  }
};

export const getLastAttributionId = (): string | null => {
  try {
    return localStorage.getItem(LAST_ATTRIBUTION_KEY);
  } catch (e) {
    return null;
  }
};

export const setLastAttributionId = (refId: string): void => {
  try {
    const firstAttributionId = getFirstAttributionId();
    localStorage.setItem(LAST_ATTRIBUTION_KEY, refId);
    if (!firstAttributionId) {
      localStorage.setItem(FIRST_ATTRIBUTION_KEY, refId);
    }
  } catch (e) {
    console.warn("Failed to set attribution ID in localStorage:", e);
  }
};

export const sendAttributionToRudderstack = (
  allstarUser?: IAllstarUser | null,
): void => {
  try {
    const firstAttributionId = getFirstAttributionId();
    const lastAttributionId = getLastAttributionId();

    if (!firstAttributionId || !lastAttributionId) {
      return;
    }
    const attributionProperties = {
      firstAttributionId,
      lastAttributionId,
    };

    analytics.identify(
      allstarUser?.user?._id || window.rudderanalytics.getAnonymousId?.(),
      attributionProperties || {},
    );
  } catch (e) {
    console.warn("Failed to send attribution data to Rudderstack:", e);
  }
};

export const processAttribution = (allstarUser?: IAllstarUser | null): void => {
  const refId = getRefFromUrl();
  if (refId) {
    setLastAttributionId(refId);
    sendAttributionToRudderstack(allstarUser);
  }
};

export const clearAttributionData = (): void => {
  try {
    localStorage.removeItem(FIRST_ATTRIBUTION_KEY);
    localStorage.removeItem(LAST_ATTRIBUTION_KEY);
  } catch (e) {
    console.warn("Failed to clear attribution data:", e);
  }
};
